import styled from 'styled-components';
import { white } from 'styles/Colors';

export const GameTaggingWrapper = styled.div`
  position: relative;

  .game-tagging {
    padding: 17px 0px 0px 15px;
    margin-top: 30px;
    text-align: center;
    color: ${white};
  }
`;

export const Title = styled.div`
  color: #fff;
  font-family: Oswald;
  font-size: 60px;
  font-style: normal;
  font-weight: 500;
  line-height: 60px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const Text = styled.div`
  color: #fff;
  text-align: center;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 25.2px;
`;

export const UpcomingGame = styled.div`
  color: #e0e0e0;
  text-align: center;
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 18.2px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Overlay = styled.div`
  opacity: 0.55;
  background: var(--scrims-full-95, rgba(0, 0, 0, 0.95));
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;
